import React, { useState } from 'react';
import SubscriptionManagement from './SubscriptionManagement';
import './Settings.css';

interface SettingsProps {
  onSubscriptionChange?: () => void;
}

export default function Settings({ onSubscriptionChange }: SettingsProps) {
  const [activeTab, setActiveTab] = useState<'subscription' | 'general'>('subscription');

  return (
    <div className="settings-container">
      <h2>Settings</h2>
      
      <div className="settings-tabs">
        <button
          className={`settings-tab ${activeTab === 'subscription' ? 'active' : ''}`}
          onClick={() => setActiveTab('subscription')}
        >
          💎 Subscription & Billing
        </button>
        <button
          className={`settings-tab ${activeTab === 'general' ? 'active' : ''}`}
          onClick={() => setActiveTab('general')}
        >
          ⚙️ General
        </button>
      </div>

      <div className="settings-content">
        {activeTab === 'subscription' && <SubscriptionManagement onSubscriptionChange={onSubscriptionChange} />}
        {activeTab === 'general' && (
          <div className="settings-placeholder">
            <p>General settings will be implemented here.</p>
          </div>
        )}
      </div>
    </div>
  );
}